import { Wording } from '@/types';

export const FITNESS_WORDING_DK: Wording = {
  components_header_media_content: 'Træningsprogrammer',
  components_header_media_1: 'For mænd',
  components_header_media_2: 'For kvinder',
  components_header_text1: 'Opskrifter',
  components_header_text2: 'Blog',
  components_header_members: 'Medlemmer',
  hero_text: 'Hold din krop i form og stærk',
  hero_button_text: 'Start din fitnessrejse',
  components_ressources_section_title: 'RESSOURCER',
  components_ressources_subheader_text:
    'Alle de ressourcer, du har brug for til en sund livsstil',
  components_ressources_span_text:
    'Nær dit velvære: Frigør en rigdom af ressourcer til holistisk sundhed og et sundt liv, herunder ekspertvejledning om fitness, ernæring og bæredygtig livsstil.',
  components_ressources_card_1_title: 'Motivering',
  components_ressources_card_1_text:
    'Korte udbrud af motivation til varige træningsvaner.',
  components_ressources_card_2_title: 'Kost',
  components_ressources_card_2_text:
    'Smarte ernæringstips til et sundere og stærkere dig.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Fitnesstræning',
  components_notes_and_google_title_2: 'Regelmæssig rutine',
  components_notes_and_google_title_3: 'Kostvedligeholdelse',
  components_review_google_text: 'Anmeldelse på Google',
  media_content_section_title: 'TRÆNING',
  media_content_section_subheader_text: 'Vores videoer',
  text_media_1: 'Mænd',
  text_media_2: 'Kvinder',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artikler og nyheder',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPSKRIFTER',
  components_text1_subheader_text: 'Sund kost til dit aktive liv',
  components_text1_span_text:
    'Madlavning med vitalitet: Udforsk en verden af ​​smagfuld fitness med vores hurtige og næringsrige opskrifter.',
  components_text1_card_1_title: 'Kickstart din dag',
  components_text1_card_1_text:
    'Start dine morgener rigtigt med næringsrige, proteinrige morgenmadsmuligheder.',
  components_text1_card_3_title: 'Power-pakkede frokoster',
  components_text1_card_3_text:
    'Opdag lækre og nemme frokostopskrifter designet til din aktive livsstil. Fra farverige salater til proteinrige wraps holder disse opskrifter dig energifyldt og fokuseret.',
  components_text1_card_2_title: 'Middage til restitution',
  components_text1_card_2_text:
    'Udforsk en række forskellige magre proteiner, fuldkorn og friske grøntsager for en tilfredsstillende afslutning på din dag.',
  components_text1_link: 'Se alle opskrifter',
  components_footer_text:
    'Løft din styrke, tænd din passion: Dit fitnesscenter, din transformation.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Privatlivspolitik',
  button_load_more: 'Indlæs mere',
  page_media_1_content_hero_text: 'Herretræning',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Tilbage',
  page_media_content_menu_chest: 'Bryst',
  page_media_content_menu_legs: 'Ben',
  page_media_content_menu_shoulders: 'Skuldre',
  page_media_content_menu_abdominals: 'Mavemuskler',
  page_media_2_content_hero_text: 'Kvinders træning',
  page_text1_hero_text: 'Opskrifter',
  page_text1_section_title: 'Ernæring',
  page_text1_subheader_text: 'Opskrifter',
  page_text2_hero_text: 'Vores blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Artikler og nyheder',
  enter_email_title: 'Indtast venligst din e-mail for at fortsætte',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Indtast',
  components_login_success_text: 'Login lykkedes!',
  components_card_link_media_content: 'Se nu',
  components_card_link_text1_content: 'Se opskrift',
  components_card_link_text2_content: 'Se artikel',
  page_media_content_menu_all: 'ALLE',
};
